/**
 * Custom Values List - Show More/Less Functionality
 * Toggles description truncation on button click
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const showMoreButtons = document.querySelectorAll('.c-values-list__show-more');
    
    showMoreButtons.forEach(button => {
      const wrapper = button.closest('.c-values-list__card-description-wrapper');
      const description = wrapper?.querySelector('.c-values-list__card-description');
      
      // Hide button if text doesn't need truncation (already fits in 3 lines)
      if (description && wrapper && wrapper.classList.contains('c-values-list__card-description-wrapper--truncated')) {
        // Check if content is actually truncated by comparing heights
        // When truncated, scrollHeight should be greater than clientHeight
        const isTruncated = description.scrollHeight > description.clientHeight;
        
        if (!isTruncated) {
          // Text fits in 3 lines, hide the button
          button.style.display = 'none';
          return;
        }
      }
      
      button.addEventListener('click', handleShowMoreClick);
    });
  }

  function handleShowMoreClick(event) {
    const button = event.currentTarget;
    const wrapper = button.closest('.c-values-list__card-description-wrapper');
    
    if (!wrapper) return;

    const isExpanded = wrapper.classList.contains('c-values-list__card-description-wrapper--expanded');
    
    if (isExpanded) {
      // Collapse
      wrapper.classList.remove('c-values-list__card-description-wrapper--expanded');
      button.setAttribute('aria-expanded', 'false');
    } else {
      // Expand
      wrapper.classList.add('c-values-list__card-description-wrapper--expanded');
      button.setAttribute('aria-expanded', 'true');
    }
  }
})();
